import { render, staticRenderFns } from "./unreply.vue?vue&type=template&id=25a1b3f6&scoped=true"
import script from "./unreply.vue?vue&type=script&lang=js"
export * from "./unreply.vue?vue&type=script&lang=js"
import style0 from "./unreply.vue?vue&type=style&index=0&id=25a1b3f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a1b3f6",
  null
  
)

export default component.exports